import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { catchError, map, of, tap } from 'rxjs';
import { MasterDataService } from '../../../../services/master-data.service';
import { Equipment } from '../../../../models/equipment.model';
import { ToastrService } from '../../../../services/toastr-service';

export function equipmentMaximumRepairCostValidator(masterDataService: MasterDataService, toastrService: ToastrService): AsyncValidatorFn {
  return (control: AbstractControl) => {
    var equipment = control.value as Equipment;
    if (!equipment) return of(null);
    if (control.invalid) return of(null);
    return masterDataService.getEquipmentRemark(equipment?.equipmentNumber ?? '').pipe(
      map((result) => {
        if (result) {
          if (result.displayRemark === true && result.maximumRepairCost === 0) {
            return { equipmentMaximumRepairCostValidator: { value: result.message } };
          } else if (result.displayRemark === true && (result.maximumRepairCost === null || result.maximumRepairCost)) {
            toastrService.showToastr(result.message, 'warning', { duration: 60000 });
          }
        }
        return null;
      }),
      catchError((error) => {
        return of({ equipmentMaximumRepairCostValidator: { value: 'Unable to verify maximum repair limit for this equipment' } });
      }),
    );
  };
}
